<template>
    <div class="material-table-expand">
        <div class="material-table-expand-con">
            <div class="material-table-expand-header">
                <div class="left">
                    <span>投放场景：{{ rows.delivery_scene_name }};</span>
                    <span>投放版位：{{ rows.delivery_type_name }};</span>
                    <span v-if="rows.material_duration">素材时长：{{ rows.material_duration }}</span>
                    <span>素材标签：
                     <template v-if="rows.label_list && Array.isArray(rows.label_list) && rows.label_list.length !== 0">
                        <span v-for="(item, index) in rows.label_list" :key="index" class="pr6">{{item.name}};</span>
                     </template>
                     <span v-else>-</span>
                </span>
                </div>
                <div class="right">
<!--                    <span>剩余可指派数量：{{rows.material_num - rows.surplusNum }}</span>-->
                </div>

            </div>

            <div class="material-table-expand-cards">
                <h5 class="title mb6">分配明细</h5>
                <div v-if="tagsActive == 1">
                    <el-table :data="tableData"
                              :header-cell-style="{ background: '#f8f8f8', color: '#333' }"
                              style="width: 100%"
                              size="mini"
                              ref="table">
                        <el-table-column
                            prop="producer"
                            label="制作人"
                            width="'33%'">
                            <template slot-scope="scope">
                                <span>{{scope.row.producer}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="num"
                            label="需求数量"
                            width="'34%'">
                        </el-table-column>
                        <el-table-column
                            prop="finish_time"
                            label="制作完成日期"
                            width="'33%'">
                        </el-table-column>
                    </el-table>
                </div>
                <div v-else-if="tagsActive == 2">
                    <el-table :data="tableData"
                              :header-cell-style="{ background: '#f8f8f8', color: '#333' }"
                              style="width: 100%"
                              size="mini"
                              ref="table">
                        <el-table-column
                            prop="producer"
                            label="制作人"
                            width="'25%'">
                            <template slot-scope="scope">
                                <span>{{scope.row.producer}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="num"
                            label="需求数量"
                            width="'25%'">
                        </el-table-column>
                        <el-table-column
                            prop="upload_num"
                            label="已上传素材数量"
                            width="'25%'">
                        </el-table-column>
                        <el-table-column
                            prop="finish_time"
                            label="制作完成日期"
                            width="'25%'">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MaterialExtendItem from "@/views/workOrder/components/materialExtendItem.vue";
export default {
    name:'assignInfo_tableExpand',
    components:{
        MaterialExtendItem
    },
    props:['orderId', "tagsActive", "rows"],
    data() {
        return {
            activeTableExpandName: 'ready',
            checked: true,
            surplusNum: 0,
            tableData: []
        }
    },
    watch:{
        'rows': {
            handler(n) {
                if(n?.detail_assign) {
                    this.tableData = n.detail_assign
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {

    },
    methods:{
    }
}
</script>
<style lang="scss" scoped>
.material-table-expand{
    padding:0 10px;
    .material-table-expand-header{
        display: flex;
        justify-content: space-between;
        .left{
            display: flex;
            flex-wrap: wrap;
            span{
                padding-right: 20px;
                padding-bottom: 6px;
            }
        }
        .right{
            width: 200px;
            text-align: right;
        }
    }
    .material-table-expand-cards{
        width: 100%;
        padding: 6px;
        border: 1px solid #dadada;
        background-color: white;
        .title{
            font-size: 12px;

        }
    }
    .pr6{
        padding-right: 6px!important;
    }
}
</style>
<style lang="scss">
</style>
